<div class="image__uploader p-2">
  <div class="app__close--icon mr-[15px] mt-[10px]">
    <button matTooltipPosition="above" data-dismiss="modal" (click)="closeDialog()" class="web-close-btn">
      <span class="material-icons" style="position: relative">clear</span>
    </button>
  </div>

  <!--
  <div class="closebuttonMobile">
    <button type="button" class="close add-close-button" (click)="closeDialog()">
      <i class="material-icons" style="font-size: 34px">close</i>
    </button>
  </div> -->

  @if (loginStateObject) {
    <h3 class="image__uploader--title mt-[40px]">{{ data.title ?? 'My Profile Picture' }}</h3>
  }
  <!-- <h3 *ngIf="loginStateObject && imageUploadedSuccess && !showdiv" class="addPhotoText">Update Photo</h3> -->

  <div class="image__uploader--dropzone p-4">
    @if (!showdiv && !imageUploadedSuccess) {
      <div>
        <div class="image__uploader--dropzone--img">
          <img mat-card-image src="../../../assets/images/profile-placeholder.png" alt="Profile Image" class="h-[180px]" />
        </div>
      </div>
    }

    @if (format == 'image' && data.type == 'org') {
      <div>
        <div>
          <image-cropper
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true"
            [containWithinAspectRatio]="containWithinAspectRatio"
            [aspectRatio]="1"
            [resizeToWidth]="180"
            [resizeToHeight]="180"
            [onlyScaleDown]="true"
            [roundCropper]="false"
            [canvasRotation]="canvasRotation"
            [transform]="transform"
            [alignImage]="'center'"
            [style.display]="showCropper ? null : 'none'"
            format="jpeg"
            (imageCropped)="imageCropped($event)"
            (imageLoaded)="imageLoaded()"
            (cropperReady)="cropperReady($event)"
            (loadImageFailed)="loadImageFailed()"
            class="w-[180px] h-[180px] min-w-[180px] min-h-[180px]"
          ></image-cropper>
        </div>
      </div>
    }
    @if (format == 'image' && data.type != 'org') {
      <div>
        <div>
          <image-cropper
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true"
            [containWithinAspectRatio]="containWithinAspectRatio"
            [aspectRatio]="1"
            [resizeToWidth]="180"
            [resizeToHeight]="180"
            [onlyScaleDown]="true"
            [roundCropper]="true"
            [canvasRotation]="canvasRotation"
            [transform]="transform"
            [alignImage]="'center'"
            [style.display]="showCropper ? null : 'none'"
            format="jpeg"
            (imageCropped)="imageCropped($event)"
            (imageLoaded)="imageLoaded()"
            (cropperReady)="cropperReady($event)"
            (loadImageFailed)="loadImageFailed()"
            [isSquareImage]="isSquareImage"
            class="w-[180px] h-[180px] min-w-[180px] min-h-[180px]"
          ></image-cropper>
        </div>
      </div>
    }

    @if (loginStateObject && imageUploadedSuccess && !showdiv) {
      <div class="image__uploader--dropzone--img">
        <img mat-card-image [src]="this.loginStateObject.profile_image_url" alt="Profile Image" style="border-radius: 100%; height: 180px" />
      </div>
    }
    <div class="flex justify-center mt-4">
      <button type="submit" class="image__uplader--upload--img" style="border: 1px solid #25508e" (click)="fileUpload.click()">
        <img src="../../../../assets/images/upload.svg" />
        Upload Image
      </button>
    </div>

    <input type="file" style="display: none" #fileUpload (change)="fileChangeEvent($event)" id="fileUpload" name="fileUpload" />
  </div>

  <div
    class="edit__profile-footer sm:mt-[25px] mt-0 sm:ml-[-8px] sm:mr-[-8px]"
    [style]="screenWidth > 640 ? 'box-shadow: -2px -1px 15px rgba(0, 0, 0, 0.1); border-radius: 0px 0px 16px 16px' : ''"
    >
    <button
      mat-raised-button
      class="w-[226px] h-[48px]"
      [class]="this.croppedImage || this.format ? 'app__btn--primary--medium' : 'app__btn--disabled--medium'"
      (click)="(this.croppedImage || this.format) && uploadFiles()"
      >
      Save
    </button>
  </div>
</div>

@if (showLoader) {
  <div>
    <div class="loading-spinner loader-overlay">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}
